import { Redirect } from '../types/Redirect';
import { buildBookingComTrackingLabel } from './buildBookingComTrackingLabel';

const ACCOMMODATION_FALLBACK_DEEP_LINK =
  'http://hotels.goeuro.com/?aid=1304384&utm_source=goeuro&utm_medium=SPPC&utm_content=cm2';

export function buildBookingComFallbackUrl(redirect: Redirect): string {
  const trackingLabel = buildBookingComTrackingLabel(redirect);
  const fallbackUrl = `${ACCOMMODATION_FALLBACK_DEEP_LINK}&label=${trackingLabel}`;
  return fallbackUrl;
}
